import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const referenceMaterialRoutes: RouteObject[] = [
  {
    path: '/reference-material',
    element: <Outlet />,
    handle: {
      documentTitle: 'Reference Material',
      crumb: () => ({ label: 'Reference Material', to: '/reference-material' })
    },
    children: [
      {
        index: true,
        element: lazyElement(() => import('./List')),
      },
      {
        path: 'category',
        element: lazyElement(() => import('./CategoryList')),
        handle: {
          documentTitle: 'Reference Material Categories',
          crumb: () => ({ label: 'Categories', to: '/reference-material/category' })
        },
      },
    ],
  },
];

export default referenceMaterialRoutes;
